import { canActivate } from '@angular/fire/auth-guard';
import { Routes } from '@angular/router';
import {
  fetchAppUserResolverAllowAnon,
  redirectShortUrlGuard,
  redirectToHomeAuthPipe,
  redirectToLoginAuthGuard,
  signInAnonIfNotLoggedInGuard,
} from './routing-utils';

export const APP_ROUTES: Routes = [
  { path: '', redirectTo: 'tabs', pathMatch: 'full' },
  {
    path: 'tabs',
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.TABS_ROUTES),
    resolve: { appUser: fetchAppUserResolverAllowAnon },
    canActivate: [signInAnonIfNotLoggedInGuard],
  },
  {
    path: 'intro',
    loadComponent: () =>
      import('@pages/new-intro/new-intro.page').then((m) => m.NewIntroPage),
    resolve: { appUser: fetchAppUserResolverAllowAnon },
    ...redirectToLoginAuthGuard,
  },
  {
    path: 'login',
    loadComponent: () =>
      import('@pages/login/login.page').then((m) => m.LoginPage),
    ...canActivate(redirectToHomeAuthPipe),
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('@pages/not-found/not-found.page').then((m) => m.NotFoundPage),
    resolve: { appUser: fetchAppUserResolverAllowAnon },
  },
  {
    path: 'sandbox',
    loadComponent: () =>
      import('@pages/sandbox/sandbox.page').then((m) => m.SandboxPage),
    canActivate: [signInAnonIfNotLoggedInGuard],
    resolve: { appUser: fetchAppUserResolverAllowAnon },
  },
  {
    path: '',
    canActivate: [signInAnonIfNotLoggedInGuard],
    children: [
      {
        path: '**',
        loadComponent: () =>
          import('@pages/hangs/hangs.page').then((m) => m.HomePage),
        canActivate: [redirectShortUrlGuard],
      },
    ],
    resolve: { appUser: fetchAppUserResolverAllowAnon },
  },
];
